/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEqualDouble = createReactComponent("equal-double", "IconEqualDouble", [
  ["path", { d: "M3 10h7", key: "svg-0" }],
  ["path", { d: "M3 14h7", key: "svg-1" }],
  ["path", { d: "M14 10h7", key: "svg-2" }],
  ["path", { d: "M14 14h7", key: "svg-3" }]
]);

export { IconEqualDouble as default };
//# sourceMappingURL=IconEqualDouble.js.map
